import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  CommonApiAction,
  CommonReducerAction,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import Stepper from "../../../../../Component/Stepper";
import { ReducersTypes } from "../../../../../Constants";
import LeavePlan from "./LeavePlan";
import UnpaidLeave from "./LeavePlan/UnpaidLeave";
import NameDesc from "./NameAndDescription";
import { Validation } from "./Validation";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
class Create extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      // permissions: this.props.history.location.state.permissions,
      value: 0,
      completed: {},
      activeStep: 0,
      currentRoute: "list",
      AllStep: [],
      Breadcrums: ["Track", "Leaves", "Policy"],
      editPre: true,
      leaveType: [],
      leavepolicy: null,
      leavepolicyname: null,
      Prevdetails: [],
      permissions: {
        readOnly: !!this.props.InitLeavesPolicy.isviewmode,
        editable: false,
      },
    };
    this.ChangeSteppername = this.ChangeSteppername.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("leavespolicy,navigation");
    this.InitLeavesPolicy();
  }

  componentWillUnmount() {
    this.props.CommonReducerAction(ReducersTypes.INITLEAVESPOLICY, {});
    localStorage.setItem("selectedleaves", "");
  }

  InitLeavesPolicy = () => {
    const data = {
      isdraft: this.props.InitLeavesPolicy.isdraft,
      leavepolicyid: this.props.InitLeavesPolicy.leavepolicyid,
      leaveid: this.props.InitLeavesPolicy.leaveid || null,
      leavetypeid: [this.props.InitLeavesPolicy.leavetypeid] || null,
    };
    instance
      .post("leaves/initleavepolicy", data)
      .then((result) => {
        if (result.data.result.initleavepolicy.length > 0) {
          const { leavetypejson } = result.data.result.initleavepolicy[0];
          const AllStep = [];
          if (!this.props.InitLeavesPolicy.leaveid) {
            if (!leavetypejson) {
              this.props.history.push(`./list`);
              this.props.enqueueSnackbar("Please create a Leave Plan", {
                variant: "error",
              });
              return false;
            }
            AllStep.push({
              step: 1,
              component: (
                <NameDesc
                  onRef={(ref) =>
                    this.setState({
                      child0: {
                        ...ref,
                        onCancel: this.Cancel,
                      },
                    })
                  }
                  StepError={this.StepError.bind(this)}
                  ChangeSteppername={this.ChangeSteppername}
                  click={this.onClick}
                  leaveType={leavetypejson}
                  ChangeStepper={this.ChangeStepper}
                  step={1}
                  newPolicyCreate={this.props.newPolicyCreate}
                />
              ),
              label: (
                <FormattedMessage id="LbDescribe" defaultMessage="Describe" />
              ),
              isError: false,
            });
            if (this.props.newPolicyCreate) {
              AllStep.push({
                step: 2,
                component: (
                  <UnpaidLeave
                    onRef={(ref) =>
                      this.setState({
                        child1: {
                          ...ref,
                          onCancel: this.Cancel,
                          onSaveDraft: this.onSaveDraft,
                          onPrev: this.onPrevClick,
                        },
                      })
                    }
                    ChangeSteppername={this.ChangeSteppername}
                    StepError={this.StepError.bind(this)}
                    click={this.onClick}
                    step={2}
                    ParentIndex={0}
                    leavetypeid={4}
                  />
                ),
                label: "Unpaid Leave",
                isError: false,
              });
            }
          } else if (this.props.InitLeavesPolicy.isviewmode) {
            this.setState({
              child0: {
                onNext: this.Save,
                onCancel1: this.Cancel,
                nextButtonLabel: "Save",
              },
            });
          } else {
            this.setState({
              child0: {
                onNext: this.Save,
                onCancel: this.Cancel,
                nextButtonLabel: "Save",
              },
            });
          }
          this.setState(
            {
              AllStep,
              leaveType: leavetypejson,
              leavepolicyname: this.props.InitLeavesPolicy.leavepolicyname,
              leavepolicyid: this.props.InitLeavesPolicy.leavepolicyid,
            },
            () => {
              this.props.CommonReducerAction(ReducersTypes.LEAVESPOLICY, {
                ...this.props.InitLeavesPolicy,
                leavepolicyid: this.state.leavepolicyid,
                leavepolicyname: this.state.leavepolicyname,
                description: this.state.description,
                details: this.props.InitLeavesPolicy.details,
                policy: result.data.result.leaveplandata.policy,
              });
            },
          );
          if (!this.props.newPolicyCreate) {
            const datatemp = {
              InitLeavesPolicy: {
                ...this.props.InitLeavesPolicy,
                details: [...result.data.result.leaveplandata.details],
              },
            };
            this.props.CommonReducerAction(ReducersTypes.LEAVESPOLICY, {
              ...datatemp.InitLeavesPolicy,
            });
            this.ChangeStepper(datatemp);
          }
        } else {
          this.props.history.push(`./list`);
          this.props.enqueueSnackbar("Please create a Leave Plan", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  ChangeSteppername = (name, stepindex) => {
    const { AllStep } = this.state;
    const { details, leaveid = "" } = this.props.InitLeavesPolicy;
    // const toChangeIndex = stepindex + 1;
    const toChangeIndex = !leaveid ? stepindex + 1 : stepindex;
    if (get(details, `[${stepindex}].leavetypeid`, "")) {
      const LeaveObject = LeavePlan.find(
        (x) => x.leavetypeid == details[stepindex].leavetypeid,
      );
      const newStep = {
        step: stepindex + 1,
        component: (
          <LeaveObject.Component
            onRef={(ref) =>
              this.setState({
                [`child${stepindex + 1}`]: {
                  ...ref,
                  onCancel: this.Cancel,
                  onSaveDraft: this.onSaveDraft,
                  onPrev: this.onPrevClick,
                },
              })
            }
            ChangeSteppername={this.ChangeSteppername}
            step={toChangeIndex}
            ParentIndex={stepindex}
            leavetypeid={LeaveObject.leavetypeid}
            StepError={this.StepError.bind(this)}
            click={this.onClick}
            newPolicyCreate={this.props.newPolicyCreate}
          />
        ),
        label: name,
        isError: false,
      };
      AllStep[toChangeIndex] = newStep;
      this.setState({ AllStep });
    }
  };

  ChangeStepper = (props) => {
    console.log("propschangestepper: ", props);
    const { AllStep } = this.state;
    const Steps = [];
    const { details } = props.InitLeavesPolicy;
    for (let i = 0; i < details.length; i += 1) {
      let StepperName;
      if (
        props.InitLeavesPolicy.policy[i] &&
        props.InitLeavesPolicy.policy[i].leavename
      ) {
        StepperName = `${props.InitLeavesPolicy.policy[i].leavename}`;
      } else {
        StepperName = `${details[i].leavetypename}`;
      }
      const LeaveObject = LeavePlan.find(
        (x) => x.leavetypeid == details[i].leavetypeid,
      );
      let r = null;
      Steps.push({
        step: i + 1,
        component: (
          <LeaveObject.Component
            onRef={(ref) => {
              r = ref;
              console.log("r: ", r);
              this.setState({
                [`child${i + 1}`]: {
                  ...ref,
                  onCancel: this.Cancel,
                  onSaveDraft: this.onSaveDraft,
                  onPrev: this.onPrevClick,
                },
              });
            }}
            ChangeSteppername={this.ChangeSteppername}
            step={i + 1}
            ParentIndex={i}
            leavetypeid={LeaveObject.leavetypeid}
            StepError={this.StepError.bind(this)}
            click={this.onClick}
            newPolicyCreate={this.props.newPolicyCreate}
          />
        ),
        label: `${StepperName}`,
        isError: false,
      });

      console.log("r: ", r);
      this.setState({
        [`child${i + 1}`]: {
          ...r,
          onCancel: this.Cancel,
          onSaveDraft: this.onSaveDraft,
          onPrev: this.onPrevClick,
        },
      });
      this.setState(
        { AllStep, Prevdetails: props.InitLeavesPolicy.details },
        () => this.checkCompleted(),
      );
    }

    if (this.props.InitLeavesPolicy.leaveid) {
      AllStep.splice(0, AllStep.length, ...Steps);
    } else {
      AllStep.splice(1, AllStep.length - 1, ...Steps);
    }
    this.setState(
      { AllStep, Prevdetails: props.InitLeavesPolicy.details },
      () => this.checkCompleted(),
    );
  };

  checkCompleted = () => {
    if (this.props.InitLeavesPolicy.leavepolicyid) {
      const completed = {};
      // eslint-disable-next-line guard-for-in
      for (const step in this.state.AllStep) {
        Object.assign(completed, { [step]: true });
      }
      this.setState({ completed });
    }
  };

  onClick = () => {
    this.child.handleNext();
  };

  onPrevClick = () => {
    // this.child.handleBack();
  };

  StepError(step, error) {
    const index = this.state.AllStep.findIndex((x) => x.step == step);
    if (index != -1) {
      const { AllStep } = this.state;
      AllStep[index].isError = error;
      this.setState({ AllStep });
    }
  }

  setStep(step, completed) {
    this.setState({ activeStep: step, completed });
  }

  Cancel = () => {
    // console.log('Cancel9: ');
    localStorage.setItem("selectedleaves", "");
    this.InitLeavesPolicy();
    // const selectedleaves1 = localStorage.getItem("selectedleaves");
    // console.log('selectedleaves1: ', selectedleaves1);

    this.props.CommonReducerAction(ReducersTypes.INITLEAVESPOLICY, {});
    for (const step of this.state.AllStep) {
      step.isError = false;
    }
    const { Breadcrums } = this.state;
    Breadcrums.splice(3);
    this.setState({ Breadcrums, AllStep: this.state.AllStep }, () => {
      this.props.history.push(`./list`);
    });
  };

  check = (isdraft = false) => {
    const { InitLeavesPolicy } = this.props;
    if (!isdraft && InitLeavesPolicy.policy.length > 0) {
      const leng = InitLeavesPolicy.policy.length - 1;
      const [isError, errorMessage] = Validation(
        InitLeavesPolicy.policy[leng].leavetypeid,
        leng,
        true,
      );
      if (!isError) {
        this.Save(isdraft);
      } else {
        this.props.enqueueSnackbar(errorMessage, { variant: "error" });
      }
    } else this.Save(isdraft);
  };

  onSaveDraft = () => {
    this.check(true);
  };

  Save = (isdraft = false) => {
    const { InitLeavesPolicy } = this.props;
    const valueArr = InitLeavesPolicy.policy.map((item) => item.leavename);
    if (
      valueArr.length > 0 &&
      valueArr[valueArr.length - 1] &&
      valueArr[valueArr.length - 1].trim()
    ) {
      const isDuplicate = valueArr.some(
        (item, idx) => valueArr.indexOf(item) != idx,
      );
      if (isDuplicate) {
        this.props.enqueueSnackbar("Duplicate leave name are not allowed", {
          variant: "error",
        });
        return false;
      }
      InitLeavesPolicy.isdraft = isdraft == true ? true : false;
      instance
        .post("leaves/leavepolicy", InitLeavesPolicy)
        .then(() => {
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
          this.props.history.push(`./list`);
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    } else {
      this.props.enqueueSnackbar("Please enter valid leave name", {
        variant: "error",
      });
    }
  };

  _onDelete = () => {
    const { InitLeavesPolicy } = this.props;
    instance
      .delete(`/leaves/leavepolicy/${InitLeavesPolicy.leavepolicyid}`)
      .then(() => {
        this.props.enqueueSnackbar("Leave Policy Deleted Successfully", {
          variant: "success",
        });
        this.props.CommonReducerAction(ReducersTypes.INITLEAVESPOLICY, {});
        for (const step of this.state.AllStep) {
          step.isError = false;
        }
        const { Breadcrums } = this.state;
        Breadcrums.splice(3);
        this.setState({ Breadcrums, AllStep: this.state.AllStep }, () => {
          this.props.history.push(`./list`);
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  };

  _renderCreateForm = () => {
    const { InitLeavesPolicy } = this.props;
    console.log("InitLeavesPolicy: ", InitLeavesPolicy);
    // let save = false;
    // if (!InitLeavesPolicy.isviewmode) {
    //   if (this.props.newPolicyCreate) {
    //     if (InitLeavesPolicy.policy.length < this.state.AllStep.length - 1) {
    //       save = false;
    //     } else {
    //       save = true;
    //     }
    //   } else if (this.state.AllStep.length == 1) {
    //     save = true;
    //   } else {
    //     // if(InitLeavesPolicy.policy.length < this.state.AllStep.length - 1 ){
    //     //   save = true
    //     // }else{
    //     //   save = true
    //     // }
    //     save = true;
    //   }
    // }
    const { AllStep } = this.state;
    const stepperchilds = [];
    AllStep.forEach((d, i) => {
      this.state[`child${i}`] && stepperchilds.push(this.state[`child${i}`]);
    });
    const canSaveAsDraft =
      get(this.props, "InitLeavesPolicy.isdraft", "") ||
      !get(this.props, "InitLeavesPolicy.leavepolicyid", "");
    stepperchilds.map((x, i) => {
      console.log("x: ", x);
      InitLeavesPolicy.isviewmode && delete x.onNext;
      !canSaveAsDraft && delete x.onSaveDraft;
      console.log(" AllStep.length: ", AllStep.length);
      if (i == AllStep.length - 1 && AllStep.length != 1) {
        x.nextButtonLabel = "Save";
        x.onNext = () => this.check(false);
      }
      delete x.onPrev;
      return x;
    });
    // if (InitLeavesPolicy.isviewmode) {
    //   stepperchilds: []
    // }
    console.log("stepperchilds: ", stepperchilds);

    return (
      <div>
        <Stepper
          AllStep={this.state.AllStep}
          onRef={(ref) => (this.child = ref)}
          setStep={this.setStep.bind(this)}
          completed={this.state.completed}
          childs={[...stepperchilds]}
        />
        {/* <div className="deletebutton-wrapper">
          {InitLeavesPolicy.leavepolicyid &&
          !InitLeavesPolicy.leaveid &&
          !InitLeavesPolicy.isviewmode ? (
            <div className="deletebutton-innerwrapper">
              {this.props.permissions.editable ? (
                <span className="deletebutton1">
                  <span className="delete-option">
                    <span style={{ float: "left", margin: "0px 8px 0px 4px" }}>
                      Are you sure?
                    </span>
                    <span
                      className="cursurpointer"
                      onClick={() => this._onDelete()}
                    >
                      <svg
                        className="message-edit cursour-pointer save-icon"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#fff"
                          d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z"
                        />
                      </svg>
                    </span>
                    <span
                      className="cursurpointer"
                      onClick={() => this.Cancel()}
                    >
                      <svg
                        className="message-edit cursour-pointer close-icon"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        onClick={() => this.Cancel()}
                      >
                        <path
                          fill="#fff"
                          d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
                        />
                      </svg>
                    </span>
                  </span>
                  <svg
                    className="delete-svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path fill="none" d="M0 0h24v24H0V0z" />
                    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z" />
                  </svg>
                </span>
              ) : (
                ""
              )}
            </div>
          ) : null}
          <div className="draftclosebutton" onClick={() => this.Cancel()}>
            <span className="floatleft" style={{ marginLeft: 6 }}>
              <svg width="24" height="24" viewBox="0 0 24 24">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
            </span>
            <span className="draftclosebutton-text">Close</span>
          </div>
          {this.props.permissions.editable &&
            (!InitLeavesPolicy.isviewmode ? (
              save ? (
                <div className="draftbutton-wrapper">
                  <div
                    className="draftbutton-innerwrapper"
                    onClick={() => this.check(false)}
                  >
                    <span className="draftbutton-save">
                      <DoneAllIcon />
                      <span className="draft-option1">Save</span>
                    </span>
                  </div>
                </div>
              ) : (
                InitLeavesPolicy.isdraft && (
                  <div className="draftbutton-wrapper">
                    <div
                      className="draftbutton-innerwrapper"
                      onClick={() => this.check(true)}
                    >
                      <span className="draftbutton">
                        <span className="draft-option">Save As Draft</span>
                        <Done />
                      </span>
                    </div>
                  </div>
                )
              )
            ) : (
              ""
            ))}
        </div> */}
      </div>
    );
  };

  render() {
    const language = this.props.Language.attendancepolicy;
    return (
      <IntlProvider locale="en" messages={language}>
        <div>
          {/* <Grid container className="business-config-layout-container">
                        <Grid item xs={12} md={12} sm={12} >
                            <Breadcrumbscomponent list={this.state.Breadcrums} />
                        </Grid>
                    </Grid> */}
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              {this._renderCreateForm()}
            </Grid>
          </Grid>
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
  LEAVES_POLICY: state.LEAVES_POLICY,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      CommonApiAction: (type, method, url, data) =>
        CommonApiAction(type, method, url, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Create)));
